import { render, staticRenderFns } from "./SystemNotifications.vue?vue&type=template&id=19e01a6d&scoped=true&"
import script from "./SystemNotifications.vue?vue&type=script&lang=ts&"
export * from "./SystemNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./SystemNotifications.vue?vue&type=style&index=0&id=19e01a6d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e01a6d",
  null
  
)

export default component.exports